import { FC, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './styles.module.scss';
import { Logo } from 'shared/ui/logo';
import { useMobileMenuContext } from 'shared/contexts/mobile-menu-context';
import { useTheme } from 'shared/hooks/use-theme';
export const Header: FC = () => {
 const location = useLocation();
 const { theme, toggleTheme } = useTheme();
 const home = location.pathname === '/';
 const education = location.pathname.startsWith('/education-info');
 const menu = useRef<HTMLDetailsElement>(null);
 const { isMobileMenuOpen, isMobile, toggleMobileMenu } = useMobileMenuContext();
 const links = [[home ? '#courses' : '/courses/', 'Курсы'], [home ? '#get' : '/#get', 'Обучение'], [home ? '#process' : '/#process', 'Как начать'], [location.pathname.startsWith('/education-info') ? '/contacts/' : '#contacts', 'Контакты']];
 const closeMenu = () => { if (menu.current) menu.current.open = false; };
 useEffect(() => { closeMenu(); }, [location.pathname, location.hash]);
 useEffect(() => {
  const closeOutside = (event: PointerEvent) => { if (!menu.current?.contains(event.target as Node)) closeMenu(); };
  document.addEventListener('pointerdown', closeOutside);
  return () => document.removeEventListener('pointerdown', closeOutside);
 }, []);
 const navigation = links.map(([href,label]) => <a key={href} href={href} onClick={closeMenu} aria-current={location.pathname === href ? 'page' : undefined}>{label}</a>);
 return <>
  <div className={`${styles.before} a11y-before`} />
  <header className={`${styles.header} ${education ? styles.education : ''} a11y-header`}>
   <a href="#main-content" className={styles.skip}>К содержимому</a>
   <div className={styles.inner}>
    <Link to="/" aria-label="Ансар — главная" className={styles.brand}><Logo cropToMark /><span className={styles.brandText}><span className={styles.brandName}>Ансар</span><small>школа программирования</small></span></Link>
    <nav className={styles.navigation} aria-label="Основная навигация">{navigation}</nav>
    <a className={styles.phone} href="tel:+79953334456">+7 995 333 44 56</a>
    <button type="button" className={styles.themeToggle} onClick={toggleTheme} aria-label={theme === 'dark' ? 'Включить светлую тему' : 'Включить тёмную тему'} title={theme === 'dark' ? 'Включить светлую тему' : 'Включить тёмную тему'} data-testid="theme-toggle">
     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      {theme === 'dark' ? <><circle cx="12" cy="12" r="4" /><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5" /></> : <path d="M20 14A8.5 8.5 0 0 1 10 4a8.5 8.5 0 1 0 10 10Z" />}
     </svg>
     <span>{theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}</span>
    </button>
    <div className={styles.mobileControls}>
     {location.pathname.startsWith('/education-info') && isMobile && <button type="button" onClick={toggleMobileMenu} data-mobile-menu-button aria-expanded={isMobileMenuOpen}>Разделы</button>}
     <details ref={menu} className={styles.menu} onKeyDown={event => { if(event.key === 'Escape') { closeMenu(); menu.current?.querySelector('summary')?.focus(); } }}>
      <summary aria-label="Открыть меню"><span aria-hidden="true" className={styles.menuIcon} /><span className={styles.menuLabel}>Меню</span></summary>
      <nav aria-label="Мобильная навигация">{navigation}<a href="tel:+79953334456" onClick={closeMenu}>+7 995 333 44 56</a><a href="/education-info" onClick={closeMenu}>Сведения об организации</a></nav>
     </details>
    </div>
   </div>
  </header>
 </>;
};
